import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "../../../contexts/auth";
import "./Header.css";
import Logo_VehiDoc from "../../../img/Logo_VehiDocOr.png";

const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // useEffect(() => {
  //   document.body.style.overflow = isMenuOpen ? 'hidden' : '';
  //   onMenuToggle(isMenuOpen);
  // }, [isMenuOpen, onMenuToggle]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavigation = (sectionId, offset = 25) => {
    if (location.pathname === "/") {
      const element = document.getElementById(sectionId);
      if (element) {
        const offsetPosition = element.offsetTop - offset;
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    } else {
      navigate("/#" + sectionId);
    }
    setIsMenuOpen(false);
  };

  const handleLogoClick = (e) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate("/");
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    setIsMenuOpen(false);
  };

  const handleLogout = async () => {
    await logout();
    navigate("/");
    setIsMenuOpen(false);
  };

  const handleContactClick = () => {
  navigate("/contact");
  setIsMenuOpen(false);
};

  return (
    <header className={`header ${isScrolled ? "scrolled" : ""}`}>
      <Link to="/" className="logo" onClick={handleLogoClick}>
        <img src={Logo_VehiDoc} alt="Logo VehiDoc" />
      </Link>
      <button className="mobile-menu-btn" onClick={toggleMenu}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </button>
      <nav className={`nav-menu ${isMenuOpen ? "active" : ""}`}>
        <ul>
          <li>
            <Link
              to="/#hero"
              onClick={(e) => {
                e.preventDefault();
                handleNavigation("hero", 50);
              }}
            >
              A propos
            </Link>
          </li>
          <li>
            <Link
              to="/#features"
              onClick={(e) => {
                e.preventDefault();
                handleNavigation("features", 25);
              }}
            >
              Nos formules
            </Link>
          </li>
          <li>
            <Link
              to={
                "/contact"
              }
              onClick={handleContactClick}
            >
              Contact
            </Link>
          </li>
          {user && (
            <li>
              <button
  className="dashboard-btn"
  onClick={() => {
    if (user?.statut === "admin") {
      navigate("/admin-dashboard");
    } else if (user?.statut === "commercial") {
      navigate("/commercial-dashboard");
    } else if (user?.statut === "assistante") {
      navigate("/assistante-dashboard");
    } else {
      navigate("/dashboard");
    }
    setIsMenuOpen(false);
  }}
>
  Tableau de bord
</button>
            </li>
          )}
          <li>
            <button
              className="connexion-btn"
              onClick={() => {
                if (user) {
                  handleLogout();
                } else {
                  navigate("/login");
                  setIsMenuOpen(false);
                }
              }}
            >
              {user ? "Déconnexion" : "Connexion"}
            </button>
          </li>
        </ul>
      </nav>
    </header>
  );
};

Header.propTypes = {
  onMenuToggle: PropTypes.func.isRequired,
};

export default Header;
